import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  isMobile = false;

  constructor(
    private router: Router,

  ) {}

  ngOnInit(): void {

  }

 goDashboard() {
    this.router.navigate(['/dashboard']);
  }

  goDersProgrami() {

     var akademikMi = false;
    akademikMi = JSON.parse(
      localStorage.getItem('akademikPersonelMi') || 'false'
    );

    var path= !akademikMi ? '/ders-programi' : '/hoca-ders-programi';
    this.router.navigate([path]);
  }

  goCihazYonetimi() {
    this.router.navigate(['/cihaz-yonetimi']);
  }

  goGeriBildirim() {
    this.router.navigate(['/geri-bildirim']);
  }
}
